const nameValidation = (value) => {
  let error;
  if (!value) {
    error = "Area name is required";
  }
  return error;
};
const polygonValidation = (value) => {
  let error;
  if (!value) {
    error = "Area is required";
  }
  return error;
};

export const validation = {
  nameValidation,
  polygonValidation,
};
